<ion-content [fullscreen]="true">
  <div class="wrapper-form">
    <div *ngIf="!PersonFacade.submitted && PersonFacade.memberStatus !== 'FULL_REGISTRATION'">
      <img class="logo" src="../../../assets/icon/logo.jpg" />
      <ion-qc-person-details-form
        [personDetails]="personDetails"
      ></ion-qc-person-details-form>

      <ion-row
        ><ion-button [disabled]="PersonFacade.formIsValid" (click)="register()"
          >Υποβολή</ion-button
        ></ion-row
      >
    </div>
    <div *ngIf="PersonFacade.memberStatus === 'FULL_REGISTRATION'">
      <ion-label class="align-text">
        Ευχαριστούμε πολύ! Είσαι ήδη εγγεγραμμένος χρήστης!
      </ion-label>
    </div>

    <div *ngIf="PersonFacade.submitted">
      <ion-label *ngIf="PersonFacade.isDataUpdated" class="align-text">
        Ολοκληρώθηκε η εγγραφή σου στο Πρόγραμμα Envie Club. Ευχαριστούμε!
      </ion-label>
      <ion-label *ngIf="!PersonFacade.isDataUpdated" class="align-text">
        Ανεπιτυχής ολοκλήρωση. Προσπαθήστε ξανά!
      </ion-label>
    </div>
  </div>
</ion-content>
